import BlockPadding from '@/components/block-padding';
import common from '@/components/lexemes/common';
import { Header2 } from '@bumble/ui-kit';

import Thumbnail from 'components/stories/thumbnail';

import styles from './love-story-grid.module.scss';

export default function LoveStoryGrid({ data }: { data: any }) {
  const { stories, title } = data;

  return (
    <BlockPadding maxWidth="large">
      <div className={styles.love__stories}>
        <div className={styles.title}>
          <Header2>{title}</Header2>
        </div>

        <div className={styles.stories}>
          {stories.map((story: any, index: number) => {
            const { storyTitle, excerpt, cardImage, slug, metIn } = story || {};

            return (
              <Thumbnail
                key={index}
                title={storyTitle}
                excerpt={excerpt}
                image={cardImage}
                slug={slug}
                metIn={metIn}
                buttonText={common.lxReadMore()}
              />
            );
          })}
        </div>
      </div>
    </BlockPadding>
  );
}
